module.exports = __webpack_public_path__ + "img/down-step.18a57ced.png";